import React from 'react'
import img1 from './logo.png'

function Viewprizes() {
  return (
    <div className='container'>
        <h2 className='pr mt-3'>List Of Prizes</h2>        
        <h3 className='subyp'>Your Points - 222</h3>        
        <br/>  
        <br/>                  
        <hr style={{ color: "white" }} />
        <br/>
        <div className=" container">            
            <div className="row">
                <div className="col card prizex">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Keyboard Protector</strong>                    
                    <br/>
                    108 Points                    
                </div>
                <div className="buttonss">
                    <button className='btnred'>+</button><button className='btnred'>-</button>
                </div> 
                <h5 className='h5prize'>You've redeemed: x</h5>
                </div>
                <div className="col card prizex">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Laptop Sticker 1</strong>                    
                    <br/>
                    200 Points                    
                </div>
                <div className="buttonss">
                    <button className='btnred'>+</button><button className='btnred'>-</button>
                </div>
                <h5 className='h5prize'>You've redeemed: x</h5>
                </div>
                <div className="col card prizex">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Laptop Sleeve</strong>                    
                    <br/>
                    220 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>                
            </div>
            <div className="row">
                <div className="col card">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Laptop Sticker 2</strong>                    
                    <br/>
                    250 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>
                <div className="col card">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Pen Drive 32GB</strong>                    
                    <br/>
                    320 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>
                <div className="col card">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>USB Hub</strong>                    
                    <br/>
                    330 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>
            </div>
            <div className="row">
                <div className="col card">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Bed Study Table</strong>                    
                    <br/>
                    350 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>
                <div className="col card">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Chair Back Rest</strong>                    
                    <br/>
                    380 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>
                <div className="col card">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Cup</strong>                    
                    <br/>
                    390 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>
                </div>
            <div className="row">
                <div className="col card">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Extension Cord</strong>                    
                    <br/>
                    406 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>
                <div className="col card">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Pen Drive 64GB</strong>                    
                    <br/>
                    427 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>      
                <div className="col card">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Wired Keyboard</strong>                    
                    <br/>
                    445 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>           
            </div>            
            <div className="row">
                <div className="col card">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Cooling Pad</strong>                    
                    <br/>
                    499 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>
                <div className="col card">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>MI Smart Watch</strong>                    
                    <br/>
                    595 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>      
                <div className="col card">
                <img src={img1} className="card-img-top" alt="..." />
                <div className="prizebody">
                    <strong>Power Bank</strong>                    
                    <br/>
                    800 Points                    
                </div>
                    <div className="buttonss">
                        <button className='btnred'>+</button><button className='btnred'>-</button>
                    </div>
                    <h5 className='h5prize'>You've redeemed: x</h5>
                </div>           
            </div>
        </div>
        <div className="loginend"></div>
    </div>
  )
}

export default Viewprizes